<p-card [header]="header" content [styleClass]="styleClass" [style]="style" [subheader]="subheader">
  <p-toast
    showTransitionOptions="0ms"
    hideTransitionOptions="0ms"
    [key]="validationNotification?.key"
  ></p-toast>
  <ng-content></ng-content>
</p-card>
